export enum LIGHT_THREE_ATLAS_FRAMES {
  FLASH_HORIZONTAL = 'light-horizontal.png',
  FLASH_VERTICAL = 'light-vertical.png',
  NUMBER_DEFAULT = 'numbers/default.png',
  NUMBER_GLOW = 'numbers/glow.png',
  NUMBER_HIT = 'numbers/match.png',
  NUMBER_HIT_TRANSITION = 'numbers/match-transition.png',
  NUMBER_PLAYER_SELECTED = 'numbers/player-selected.png',
  NUMBER_SYSTEM_SELECTED = 'numbers/system-selected.png',
  NUMBER_SYSTEM_SELECTED_TRANSITION = 'numbers/system-selected-transition.png',
}

export enum LIGHT_THREE_TEXTURE_KEYS {
  ATLAS = 'LIGHT_THREE_ATLAS',
  NUMBER_DEFAULT = 'LIGHT_THREE_NUMBER_DEFAULT',
  NUMBER_HIT = 'LIGHT_THREE_NUMBER_HIT',
  NUMBER_HIT_TRANSITION = 'LIGHT_THREE_NUMBER_HIT_TRANSITION',
  NUMBER_PLAYER_SELECTED = 'LIGHT_THREE_NUMBER_PLAYER_SELECTED',
  NUMBER_SYSTEM_SELECTED = 'LIGHT_THREE_NUMBER_SYSTEM_SELECTED',
  NUMBER_SYSTEM_SELECTED_TRANSITION = 'LIGHT_THREE_NUMBER_SYSTEM_SELECTED_TRANSITION',
}
